import { Routes } from '@angular/router';
import { webViewCloseGuard } from './services/utils/guards/guards';

export const appRoutes: Routes = [
    {
        path: 'unauthorized',
        loadComponent: () => import('./components/unauthorized/unauthorized.component').then(c => c.UnauthorizedComponent)
    },
    {
        path: 'auth',
        canActivate: [() => webViewCloseGuard()],
        loadComponent: () => import('./views/auth/auth.component').then(c => c.AuthComponent)
    },
    {
        path: 'auth/link-expiry',
        loadComponent: () => import('./views/auth/expiry/payment-link-expiry.component').then(c => c.PaymentLinkExpiryComponent)
    },
    {
        path: 'product-unavailable',
        loadComponent: () => import('./views/generic/product-unavailable/product-unavailable.component').then(c => c.ProductUnavailableComponent)
    },
    {
        path: 'download',
        loadComponent: () => import('./views/generic/download-redirect/download-redirect.component').then(c => c.DownloadRedirectComponent)
    },
    {
        path: '',
        loadChildren: () => import('src/app/views/views.routes').then(m => m.viewsRoutes)
    },
    {
        path: 'home/:domain',
        loadComponent: () => import('./components/token/token.component').then(c => c.TokenComponent)
    },
    {
        path: 'home/:domain/:op/:jwt',
        loadComponent: () => import('./components/token/token.component').then(c => c.TokenComponent)
    },
    { path: '**', loadComponent: () => import('./views/generic/notfound/notfound.component').then(c => c.NotFoundComponent) }
];
